(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('@shraddhar/web/icon'), require('@angular/forms'), require('@angular/cdk/coercion'), require('rxjs'), require('rxjs/operators'), require('@material/ripple'), require('@shraddhar/web/base'), require('@shraddhar/web/ripple'), require('@material/icon-button')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/icon-button', ['exports', '@angular/core', '@angular/common', '@shraddhar/web/icon', '@angular/forms', '@angular/cdk/coercion', 'rxjs', 'rxjs/operators', '@material/ripple', '@shraddhar/web/base', '@shraddhar/web/ripple', '@material/icon-button'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.iconButton = {}), global.ng.core, global.ng.common, global.ng.web.icon, global.ng.forms, global.ng.cdk.coercion, global.rxjs, global.rxjs.operators, global.mdc.ripple, global.ng.web.base, global.ng.web.ripple, global.mdc.iconButton));
}(this, (function (exports, core, common, icon, forms, coercion, rxjs, operators, ripple, base, ripple$1, iconButton) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDC_ICON_BUTTON_CONTROL_VALUE_ACCESSOR = {
        provide: forms.NG_VALUE_ACCESSOR,
        useExisting: core.forwardRef(function () { return MdcIconButton; }),
        multi: true
    };
    /** Change event object emitted by MdcIconButton. */
    var MdcIconButtonChange = /** @class */ (function () {
        function MdcIconButtonChange(source, value) {
            this.source = source;
            this.value = value;
        }
        return MdcIconButtonChange;
    }());
    var nextUniqueId = 0;
    var MdcIconOn = /** @class */ (function () {
        function MdcIconOn() {
        }
        MdcIconOn.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcIconOn]',
                        host: { 'class': 'mdc-icon-button__icon--on' }
                    },] }
        ];
        return MdcIconOn;
    }());
    var MdcIconButton = /** @class */ (function (_super) {
        __extends(MdcIconButton, _super);
        function MdcIconButton(_ngZone, _changeDetectorRef, elementRef, ripple) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this.ripple = ripple;
            _this._uniqueId = "mdc-icon-button-" + ++nextUniqueId;
            _this._initialized = false;
            /** Emits when the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this.id = _this._uniqueId;
            _this.name = undefined;
            _this.icon = undefined;
            /* Set aria label on state. */
            _this.labelOn = undefined;
            /* Set aria label off state. */
            _this.labelOff = undefined;
            _this.onIcon = undefined;
            _this.offIcon = undefined;
            _this._on = false;
            _this._disabled = false;
            _this.change = new core.EventEmitter();
            _this._onChange = function () { };
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            _this.ripple = _this._createRipple();
            _this.ripple.init();
            return _this;
        }
        Object.defineProperty(MdcIconButton.prototype, "inputId", {
            get: function () {
                return "" + (this.id || this._uniqueId);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcIconButton.prototype, "on", {
            get: function () {
                return this._on;
            },
            set: function (value) {
                this._on = coercion.coerceBooleanProperty(value);
                this._syncIconStatus();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcIconButton.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabled(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcIconButton.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                hasClass: function (className) { return _this._root.classList.contains(className); },
                getAttr: function (attrName) { return _this._root.getAttribute(attrName); },
                setAttr: function (name, value) { return _this._root.setAttribute(name, value); },
                notifyChange: function (evtData) {
                    _this.change.emit(new MdcIconButtonChange(_this, evtData.isOn));
                    _this._onChange(_this._foundation.isOn());
                }
            };
            return new iconButton.MDCIconButtonToggleFoundation(adapter);
        };
        MdcIconButton.prototype.ngOnChanges = function (changes) {
            if (!this._initialized) {
                return;
            }
            if (changes['on']) {
                this._syncIconStatus();
            }
        };
        MdcIconButton.prototype.ngAfterViewInit = function () {
            this._foundation.init();
            this._initialized = true;
        };
        MdcIconButton.prototype.ngAfterContentInit = function () {
            var _this = this;
            this._foundation.toggle(this._on || this._foundation.isOn());
            this._changeDetectorRef.detectChanges();
            // When the icons change apply mdc icon class
            this._ngZone.runOutsideAngular(function () {
                _this.icons.changes.pipe(operators.startWith(null), operators.takeUntil(_this._destroyed))
                    .subscribe(function () {
                    _this.icons.forEach(function (icon) {
                        icon.elementRef.nativeElement.classList.add('mdc-icon-button__icon');
                        icon.role = null;
                    });
                });
            });
        };
        MdcIconButton.prototype.ngOnDestroy = function () {
            var _a, _b;
            this._destroyed.next();
            this._destroyed.complete();
            (_a = this.ripple) === null || _a === void 0 ? void 0 : _a.destroy();
            (_b = this._foundation) === null || _b === void 0 ? void 0 : _b.destroy();
        };
        MdcIconButton.prototype.writeValue = function (value) {
            this._onChange(value);
        };
        MdcIconButton.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcIconButton.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        /** Sets the button disabled state */
        MdcIconButton.prototype.setDisabled = function (disabled) {
            this._disabled = coercion.coerceBooleanProperty(disabled);
            this.disabled ? this._root.setAttribute('disabled', '') : this._root.removeAttribute('disabled');
            this._changeDetectorRef.markForCheck();
        };
        MdcIconButton.prototype.handleClick = function () {
            // Check if button can be toggled
            if (this.icons.length === 1) {
                return;
            }
            this.on = !this.on;
            this._foundation.handleClick();
        };
        MdcIconButton.prototype._syncIconStatus = function () {
            var _a;
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.toggle(this._on);
        };
        MdcIconButton.prototype._createRipple = function () {
            var adapter = __assign(__assign({}, ripple$1.MdcRipple.createAdapter(this)), { isUnbounded: function () { return true; } });
            return new ripple$1.MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcIconButton.decorators = [
            { type: core.Component, args: [{
                        selector: '[mdc-icon-button], button[mdcIconButton], a[mdcIconButton]',
                        exportAs: 'mdcIconButton',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-icon-button',
                            '[class.mdc-icon-button--on]': 'on',
                            '[attr.aria-pressed]': '!!labelOn && !!labelOff ? undefined : "false"',
                            '[attr.data-aria-label-on]': 'labelOn',
                            '[attr.data-aria-label-off]': 'labelOff',
                            '(click)': 'handleClick()'
                        },
                        template: "<mdc-icon *ngIf=\"icon\">{{icon}}</mdc-icon>\r\n<mdc-icon class=\"mdc-icon-button__icon\" mdcIconOn *ngIf=\"!!onIcon && on\">\r\n  {{onIcon}}</mdc-icon>\r\n<mdc-icon class=\"mdc-icon-button__icon\" *ngIf=\"!!offIcon && !on\">\r\n  {{offIcon}}</mdc-icon>\r\n<ng-content></ng-content>",
                        providers: [
                            MDC_ICON_BUTTON_CONTROL_VALUE_ACCESSOR,
                            ripple$1.MdcRipple
                        ],
                        changeDetection: core.ChangeDetectionStrategy.OnPush,
                        encapsulation: core.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcIconButton.ctorParameters = function () { return [
            { type: core.NgZone },
            { type: core.ChangeDetectorRef },
            { type: core.ElementRef },
            { type: ripple$1.MdcRipple }
        ]; };
        MdcIconButton.propDecorators = {
            id: [{ type: core.Input }],
            name: [{ type: core.Input }],
            icon: [{ type: core.Input }],
            labelOn: [{ type: core.Input }],
            labelOff: [{ type: core.Input }],
            onIcon: [{ type: core.Input }],
            offIcon: [{ type: core.Input }],
            on: [{ type: core.Input }],
            disabled: [{ type: core.Input }],
            change: [{ type: core.Output }],
            icons: [{ type: core.ContentChildren, args: [icon.MdcIcon, { descendants: true },] }]
        };
        return MdcIconButton;
    }(base.MDCComponent));

    var ICON_BUTTON_DECLARATIONS = [
        MdcIconButton,
        MdcIconOn
    ];
    var MdcIconButtonModule = /** @class */ (function () {
        function MdcIconButtonModule() {
        }
        MdcIconButtonModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            icon.MdcIconModule
                        ],
                        exports: __spread(ICON_BUTTON_DECLARATIONS, [
                            icon.MdcIconModule
                        ]),
                        declarations: ICON_BUTTON_DECLARATIONS
                    },] }
        ];
        return MdcIconButtonModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_ICON_BUTTON_CONTROL_VALUE_ACCESSOR = MDC_ICON_BUTTON_CONTROL_VALUE_ACCESSOR;
    exports.MdcIconButton = MdcIconButton;
    exports.MdcIconButtonChange = MdcIconButtonChange;
    exports.MdcIconButtonModule = MdcIconButtonModule;
    exports.MdcIconOn = MdcIconOn;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-icon-button.umd.js.map
